define.alias("ember-functions-as-helper-polyfill/initializers/usable-function-manager", "media/initializers/usable-function-manager");